<!-- <nav> etichettata: e' una delle due navigazioni della pagina, e con due
     landmark dello stesso ruolo l'etichetta e' obbligatoria. Non contiene la
     parola "navigazione", che il lettore di schermo aggiunge da se'. -->
<nav class="layout-sidebar" [attr.aria-label]="'Sezioni' | translate">
    <!-- iniziali + nome in testa al drawer mobile (scheda _1 pag. 20); il ruolo e' stato
         tolto il 14/09/2026 -->
    <div class="dt-sidebar-user" *ngIf="nome">
        <app-avatar-iniziali [nome]="nome"></app-avatar-iniziali>
        <div class="dt-sidebar-user-txt">
            <span class="dt-sidebar-user-nome">{{ nome }}</span>
        </div>
    </div>
    <div #menuContainer class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</nav>
